import controller from './settings.controller';
import template from './settings.pug';

const SettingsComponent = {
  controller,
  template,
};

export default SettingsComponent;



// WEBPACK FOOTER //
// ./client/app/settings/settings.component.js